import { useEffect, useState } from "react"
import { useQueryClient, useQuery } from "react-query"
import { useAuth } from "../../../modules/auth"
import {Helmet} from "react-helmet"

import { PageTitle } from "../../../../_metronic/layout/core"
import Table from "../../../components/Table/Table"
import GeneralPagination from "../../../components/Pagination/GeneralPagination"

import { getSchedules } from "../../../models/courses/schedules"
import ScheduleFilter from "./components/ScheduleFilter"
import { scheduleColumns, columnAliases } from "./components/ScheduleTable/_columns"


const Schedules = () => {
    const { currentUser: { role_id: roleId } } = useAuth()

    const pageSize = 15
    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState({
        status: {
            label: 'On Going',
            value: 'active'
        },
        have_schedule_code: 1
    })
    const [page, setPage] = useState(1)
    const [sortBy, setSortBy] = useState({
        id: "start_at",
        direction: "ASC"
    })

    const queryClient = useQueryClient()
    const { isLoading, isFetching, isError, error, data, isSuccess } = useQuery(['course-all-schedules'], () => getSchedules({
        courseId: filters?.course?.value,
        userId: filters?.mentor?.value,
        startAt: filters?.start_at?.value,
        status: filters?.status?.value,
        haveScheduleCode: filters?.have_schedule_code,
        page,
        rows: pageSize,
        sortBy
    }))

    useEffect(() => {
        queryClient.fetchQuery('course-all-schedules')
    }, [queryClient, filters, page, sortBy])

    return (
        <>
            <Helmet>
                <title>All Schedules</title>
            </Helmet>
            <div className="min-h-500px">
                <PageTitle>All Schedules</PageTitle>
                <div className="card">
                    <div className="card-header p-6 d-block">
                        <div className="d-flex justify-content-between">
                            <button type="button" className={"btn btn-sm me-3 " + (showFilter ? 'btn-primary' : 'btn-light-primary')} onClick={() => setShowFilter(item => !item)}><i className="fa fa-filter"></i> Filter</button>
                        </div>
                        <ScheduleFilter
                            defaultValues={filters}
                            show={showFilter}
                            queryClient={queryClient}
                            onSubmit={values => {
                                setPage(1)
                                setFilters(values)
                            }}
                        />
                    </div>
                    <div className="card-body p-6">
                        <Table
                            columns={scheduleColumns}
                            isLoading={isFetching}
                            isError={isError}
                            error={error}
                            data={!isLoading ? data.data : []}
                            currentPage={page}
                            pageSize={pageSize}
                            defaultSortBy={{
                                id: 'schedule_start',
                                desc: false
                            }}
                            onSortByChange={sortBy => setSortBy(() => {
                                if (sortBy.length) return {
                                    id: sortBy[0].id in columnAliases ? columnAliases[sortBy[0].id] : sortBy[0].id,
                                    direction: sortBy[0].desc ? 'DESC' : 'ASC'
                                }
                        
                                return {}
                            })}
                            roleId={roleId}
                        />
                        
                        {isSuccess && <GeneralPagination
                            onPageChange={page => setPage(page)}
                            totalCount={data?.meta.total}
                            currentPage={page}
                            pageSize={pageSize}
                            from={data?.meta.from}
                            to={data?.meta.to}
                        />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Schedules